export const cameraPositions = {
  init: { camera: [105878, 34216.1, -108422.4], target: [70895.3, -831.4, -111712.1] },
  wide: { camera: [94543.3, 22574.2, -108422.4], target: [70165.6, 111.7, -109970.8] },
  site: { camera: [61486.3, 11591.7, -108170.5], target: [69721.1, 1376.2, -111183.3] },
  blockE: { camera: [62065.4, 9711.3, -109705.7], target: [69280.9, 1722, -108193.3] },
  blockK: { camera: [65405.1, 9600.5, -113771.8], target: [69862.3, 109.2, -111930] },
  blockF: { camera: [67405.1, 9600.5, -113771.8], target: [74500, 169.2, -113130] },
  blockJ: {
    camera: [63072.9, 5981.3, -109893.4],
    target: [67516.056653, 169.2, -113926.393542]
  },
  blockH: {
    camera: [65072.9, 5981.3, -119893.4],
    target: [71760.6911355944, 169.2, -120094.17736203468]
  },
  buildingJ: {
    camera: [63072.9, 5981.3, -109893.4],
    target: [67516.056653, 6.3366353, -113926.3935426]
  },
  buildingE: { camera: [63072.9, 6981.3, -109893.4], target: [69246.9, 1722, -108200.6] },
  buildingK: { camera: [67490.7, 3346.9, -111181], target: [69959.6, 109.2, -111897.7] },
  buildingF: { camera: [67490.7, 3346.9, -111181], target: [67959.6, 109.2, -111897.7] },
  buildingH: { camera: [67490.7, 3346.9, -111181], target: [67959.6, 109.2, -111897.7] }
}
